const FirebaseConfig = {
  apiKey: "AIzaSyDTe3tOWoC6B08UiWU_u9WLwSfwDUHAza8",
  authDomain: "web-keperin.firebaseapp.com",
  projectId: "web-keperin",
  storageBucket: "web-keperin.appspot.com",
  messagingSenderId: "685045196031",
  appId: "1:685045196031:web:277af243b44e932b8d98ca",
  measurementId: "G-4YJ4JQRX8C",
};

export default FirebaseConfig;